// src/components/AboutContent/AboutContent.tsx
import React from 'react';
import './AboutContent.css';

const AboutContent: React.FC = () => {
  return (
    <section className="about-section">
      <div className="container">
        <div className="about-content">
          <h1>About Me</h1>
          
          <div className="about-image-container">
            <img 
              src="/KaviImage.jpeg" 
              alt="Astrologer Kavitha Nandy"
              className="about-image"
              onError={(e) => {
                // Fallback if image doesn't exist
                (e.target as HTMLImageElement).style.display = 'none';
              }}
            />
          </div>
          
          <div className="story-content">
            <p>
              I grew up in a family deeply rooted in astrology. My grandfather, Professor K. V. Sahukar, was a respected astrologer and founder of the Manjunatha Astrological Mission. Alongside his work, he managed the Shri Shringeri Shankaracharya Mutt in Nashik, India, for more than 50 years. Astrology was not just his profession, it was his life's calling. His guidance drew countless clients, with waitlists stretching for months, as people sought clarity and purpose in their lives.
            </p>

            <p>
              As a child, I witnessed this world closely, yet I questioned it deeply. How could planets and stars light-years away influence human lives and karma? And how could an astrologer, a human like us, predict the trajectory of someone's life? My grandfather's subscription to Dr. B. V. Raman's Astrological Magazine became my window into this world, and though I read it with skepticism, curiosity quietly replaced defiance.
            </p>

            <p>
              What began as resistance slowly evolved into passion. Without realizing it, I had become an astrology enthusiast, dedicating myself to study and research. Over the past 15 years, I have immersed myself in Vedic astrology, particularly the Brihat Parashara Hora Shastra, which forms the foundation of my birth chart analysis. My professional training includes certifications under professors who are direct disciples in the lineage of Dr. K. N. Rao, the founder of Bharatiya Vidya Bhavan in Delhi.
            </p>

            <p>
              In parallel with my astrological journey, I have also built a career in banking, education, entrepreneurship and non-profits administration with over a decade of experience managing client relations and community engagement. These skills enrich my astrology practice, allowing me to combine empathy, professionalism, and clarity when guiding clients.
            </p>

            <p>
              Today, astrology is not just something I practice, it is a way of life. I carry forward my grandfather's legacy with a modern perspective, helping people understand that whatever unfolds in life is ultimately for their growth, and that the cosmic design at birth holds the key to unlocking purpose, timing, and direction.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutContent;